module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.dunsnumber))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Duns Number")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.cageid))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Cage ID")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Federal Contractor")])], 1), _vm._v(" "), _c('v-list-action', [(_vm.props.item.fedcontractor) ? _c('v-chip', {
    attrs: {
      "color": "green",
      "text-color": "white"
    }
  }, [_c('v-card-text', [_vm._v("YES")])], 1) : _vm._e(), _vm._v(" "), (!_vm.props.item.fedcontractor) ? _c('v-chip', {
    attrs: {
      "color": "red",
      "text-color": "white"
    }
  }, [_c('v-card-text', [_vm._v("NO")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Federal Contractor Type")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.fedcontractortype))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Security Clearance")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.securityclearance))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary NAICS Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.primarynaicscode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional NAICS Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.additionalnaicscodes))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary PSC Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.primarypsccode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional PSC Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.additionalpsccodes))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a8c7572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Request/company/contract_info.vue
// module id = 1231
// module chunks = 3 4